import { Injectable } from '@angular/core';
import { Query } from '@datorama/akita';
import { LeaderboardV2Entry } from './models/leaderboard-v2.model';
import { LeaderboardV2Store, LeaderboardV2State } from './leaderboard-v2.store';

@Injectable({ providedIn: 'root' })
export class LeaderboardV2Query extends Query<LeaderboardV2State> {
  constructor(protected store: LeaderboardV2Store) {
    super(store);
  }

  getLeaderboardV2() {
    return this.getValue().leaderboardV2;
  }

  getMonthlyLeaderboardV2() {
    return this.getValue().monthlyLeaderboardV2;
  }

  getEachMonthLeaderboardV2() {
    return this.getValue().leaderboardV2;
  }

  /**
   * Format the array to show amount to display and then add user if not in the array
   */
  formatArrayWithUser(amountToDisplay: number, items: LeaderboardV2Entry[]) {
    if (!items) return;
    let currentUserIndex = items.findIndex((l) => l.IsCurrentUser === true);
    let currentUser = items[currentUserIndex];

    let slicedArray = items.slice(0, amountToDisplay - 1);

    if (slicedArray.some((l) => l.IsCurrentUser === true)) {
      if (items[amountToDisplay - 1]) {
        slicedArray.push(items[amountToDisplay - 1]);
      }
    } else {
      if (currentUser) {
        slicedArray.push(currentUser);
      }
    }

    if (slicedArray.length > 1) {
      slicedArray.forEach(function (item, i) {
        if (item.IsCurrentUser === true) {
          slicedArray.splice(i, 1);
          slicedArray.unshift(item);
        }
      });
    }

    return slicedArray;
  }
}
